export type PrimaryColor = 'floodwaive' | 'blue'; // Simplified

export interface ColorPalette {
  50: string;
  100: string;
  200: string;
  300: string;
  400: string;
  500: string;
  600: string;
  700: string;
  800: string;
  900: string;
  950: string;
}

// PrimeNG color mappings
export const PRIMENG_COLORS: Record<PrimaryColor, ColorPalette> = {
  // FloodWaive Default
  floodwaive: {
    50: '#e8f5fa',
    100: '#d1ebf5',
    200: '#a3d7eb',
    300: '#75c3e1',
    400: '#47afd7',
    500: '#2FA5CC',
    600: '#2684a3',
    700: '#1d637a',
    800: '#1a5266',
    900: '#143d4d',
    950: '#0f2a35',
  },
  // Fallback
  blue: {
    50: '#eff6ff',
    100: '#dbeafe',
    200: '#bfdbfe',
    300: '#93c5fd',
    400: '#60a5fa',
    500: '#3b82f6',
    600: '#2563eb',
    700: '#1d4ed8',
    800: '#1e40af',
    900: '#1e3a8a',
    950: '#172554',
  }
};


